module.exports = __webpack_public_path__ + "static/media/engine-fan_1.c550acab.png";